
import GenreMaker from '../anychart/genreMaker'; 

var PieChart = class PieChart extends GenreMaker {

    setData(state){
        super.setData(state);
        //pie只有单系列，此处使用数组是为了配合其他图形数据格式
        this.chart = anychart.pie(this.data[0]);
        if(this.ifIncluded("doughnut")){ 
              this.chart.innerRadius("30%");
        }
          return this.chart;
    }

    createChart(){
        //var chart = anychart.pie();
        //return chart;
        return null;
    }; 
};


    
GenreMaker.pie = PieChart;

export var PieChart;



// WEBPACK FOOTER //
// ./src/anychart/pieChart.js